import React,{useState}  from 'react'
import styles from './Productf1.module.css'
import Art from '../Image/fa.jpg'
import Mug from '../Image/fc2.jpg'
import Laptop from '../Image/laptop.jpg'
import Head from '../Image/head.jpg'
import Watch from '../Image/watchone.jpg'
import Phone from '../Image/phone.jpg'
import Post from '../Image/poster.jpg'
import Shoe from '../Image/shoes.jpg'
import tshirt from '../Image/tshirt.jpg'
import {AiOutlineRight} from 'react-icons/ai'
import { Link} from 'react-router-dom';
import Modal from 'react-modal';
import {MdCancel} from 'react-icons/md'



Modal.setAppElement('#root');
function Product() {

    const [modalIsOpen,setModalIsOpen] = useState(false);

    function handlemodelclose()
{
    setModalIsOpen(false);
}

function handlemodel()
{
  
    setModalIsOpen(true);
  }




    return (
        <div className={styles.container}>
            <div className={styles.topshow}>
          <span className={styles.showitem}> <h1>Showing 1-8 of 9 results</h1></span> 
          <div className={styles.dropdownbox}>
              <span className={styles.drop}>
                  <select className={styles.itemss}>
                       <option className={styles.option} >Default Sorting</option>
                      <option className={styles.option}>Price High to Low</option>
                      <option className={styles.option}>Price Low to Hight</option>
                      
                  </select>
              </span>
          </div>
          </div>
           
      {    /* productlist */}

          <div className={styles.listone}>
              <span className={styles.firstcard}  >
                  <div className={styles.firstcard} onClick={()=>handlemodel()}>
                      <div className={styles.sale}><p className={styles.saletext}>Sale!</p></div>
             <img src={Art} alt="art" className={styles.firstimg}  ></img>
             <h1 className={styles.imgname}>Art</h1>
           <span><p className={styles.rate}>$399.00</p></span><span><h4 className={styles.offer}>$99.00</h4></span>
                  </div>
                </span>
              <span className={styles.secondlist}>
                  <div className={styles.secondcard} onClick={()=>handlemodel()}>
                  <img src={Mug} alt="mug" className={styles.firstimg}   ></img>
             <h1 className={styles.imgname}>Mug Mockup</h1>
          <span><h4 className={styles.offer1}>$59.00</h4></span>
                  </div>
                  </span>
              <span className={styles.thiredlist}>
              <div className={styles.thiredcard} onClick={()=>handlemodel()}>
              <div className={styles.sale}><p className={styles.saletext}>Sale!</p></div>
              <img src={Laptop} alt="laptop" className={styles.firstimg}   ></img>
             <h1 className={styles.imgname}>Laptops</h1>
           <span><p className={styles.rate}>$250.00</p></span><span><h4 className={styles.offer}>$150.00</h4></span>
                  </div>
                  </span>
          </div>
          <div className={styles.listtwo}>
              <span className={styles.firstcard}>
                  <div className={styles.firstcard} onClick={()=>handlemodel()}>
                      
             <img src={Head} alt="headset" className={styles.firstimg}></img>
             <h1 className={styles.imgname}>Headphone</h1>
             <span><h4 className={styles.offer1}>$89.00</h4></span>
                  </div>
                </span>
              <span className={styles.secondlist}>
                  <div className={styles.secondcard} onClick={()=>handlemodel()}>
                  <img src={Watch} alt="watch" className={styles.firstimg}></img>
             <h1 className={styles.imgname}>Watches</h1>
          <span><h4 className={styles.offer1}>$145.00</h4></span>
                  </div>
                  </span>
              <span className={styles.thiredlist}>
              <div className={styles.thiredcard} onClick={()=>handlemodel()}>
              <div className={styles.sale}><p className={styles.saletext}>Sale!</p></div>
              <img src={Phone} alt="phone" className={styles.firstimg}></img>
             <h1 className={styles.imgname}>Phone</h1>
           <span><p className={styles.rate}>$550.00</p></span><span><h4 className={styles.offer}>$70.00</h4></span>
                  </div>
                  </span>
          </div>
          <div className={styles.listthree}>
              <span className={styles.firstcard}>
                  <div className={styles.firstcard} onClick={()=>handlemodel()}>
                      
             <img src={Post} alt="poster" className={styles.firstimg}></img>
             <h1 className={styles.imgname}>Poster</h1>
             <span><h4 className={styles.offer1}>$89.00</h4></span>
                  </div>
                </span>
              <span className={styles.secondlist}>
                  <div className={styles.secondcard} onClick={()=>handlemodel()}>
                  <img src={Shoe} alt="shoe" className={styles.firstimg}></img>
             <h1 className={styles.imgname}>Shoes</h1>
          <span><h4 className={styles.offer1}>$139.00</h4></span>
                  </div>
                  </span>
              <span className={styles.thiredlist}>
              <div className={styles.thiredcard} onClick={()=>handlemodel()}>
              
              <img src={tshirt} alt="tshirt" className={styles.firstimg}></img>
             <h1 className={styles.imgname}>T-shirt</h1>
             <span><h4 className={styles.offer1}>$69.00</h4></span>
                  </div>
                  </span>
          </div>
          
          {    /* Pagination */}

          <div className={styles.footer}>
              <ul className={styles.pageno}>
              <Link to='' className={styles.link}>   <li className={`${styles.pagename} + " " + ${styles.active}`}><p className={styles.no}>1</p></li></Link> 
              <Link to='/pageno2' className={styles.link}>  <li className={styles.pagename}><p className={styles.no}>2</p></li></Link>
                  <li className={styles.pagename}><p className={styles.no}>3</p></li>
                  <li className={styles.pagename}><p className={styles.no}><AiOutlineRight /></p></li>
              </ul>
          </div>
          <Modal isOpen={modalIsOpen} className={styles.model}>
           
       <MdCancel
        className={styles.cancel}
        size={40}
        onClick={()=>handlemodelclose()}
        />
        <h1 className={styles.heading}>Edit Product</h1>
        <form className={styles.formdata}>
           
          <div className={styles.producttitleare}>
          <lable className={styles.protitle}>Product Title</lable>
          <input type="text" className={styles.producttitle} placeholder="Enter product title" required></input>
          </div>
          <div className={styles.producttitleare}>
          <lable className={styles.protitle}>Price</lable><br></br>
          <input type="text" className={styles.producttitle} placeholder="Enter price" required></input>
          </div>
          <div className={styles.producttitleare}>
          <lable className={styles.protitle}>Upload Product Image</lable><br/>
          <input type="file" className={styles.file}  required></input>
          </div>
          <hr className={styles.hr1}></hr>
          <div className={styles.btns}>
              <input type="button" className={styles.cancelbtn} value="Cancel" onClick={()=>handlemodelclose()} />
              <input type="submit" className={styles.savebtn} value="Save" />
          </div>
        </form>
        </Modal>
        </div>
    )
}

export default Product
